import './style.scss';

import { Controller, get } from 'react-hook-form';

import { InputNumber } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function PercentageInput({
  label,
  name,
  placeholder,
  min = 0,
  max = 100,
  isRequired,
  disabled,
  control,
  errors,
  onCustomChange,
  isFontWeightLabel,
  readOnly,
  defaultValue,
}) {
  const { t } = useTranslation();
  return (
    <div className="field">
      <label htmlFor={name} style={isFontWeightLabel ? { fontWeight: 900 } : {}}>
        {label}{' '}
        {isRequired && (
          <span className="text-red-500" style={{ fontWeight: 900 }}>
            *
          </span>
        )}
      </label>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue ?? 0}
        render={({ field: { onChange, value, ref } }) => (
          <InputNumber
            inputId={name}
            value={value ?? 0}
            onValueChange={(e) => {
              onChange(e.value);
              if (onCustomChange) {
                onCustomChange(name, e.value);
              }
            }}
            placeholder={placeholder}
            min={min}
            max={max}
            suffix="%"
            ref={ref}
            className={classNames('percentage', {
              'p-invalid': !!get(errors, name),
              'surface-200': disabled,
              'opacity-100': readOnly,
            })}
            inputStyle={{
              textAlign: 'right',
              ...(readOnly && { opacity: 1 }),
            }}
            tooltip={t(get(errors, name)?.message)}
            tooltipOptions={{ position: 'bottom' }}
            disabled={disabled || readOnly}
          />
        )}
      />
    </div>
  );
}

PercentageInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}),
  onCustomChange: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  isFontWeightLabel: PropTypes.bool,
  readOnly: PropTypes.bool,
  defaultValue: PropTypes.number,
};

PercentageInput.defaultProps = {
  label: '',
  placeholder: '',
  isRequired: false,
  disabled: false,
  errors: {},
  onCustomChange: () => {},
  min: 0,
  max: 100,
  isFontWeightLabel: false,
  readOnly: false,
  defaultValue: 0,
};
